

export const workType = ['On-site', 'Remote', 'Hybrid']

export const lungueges = ['Hindi', 'Marathi', "Telugu", "Malayalam", 'Gujarati']


export const companyType = ['Public company', "Self employed", "Government agency", "Non-profit", "Sole proprietorship", "Privately held", "Partnership"]

export const companySize = ['1–10', '10–50', '50–100', '100–200', '200–500', '500–1,000', '1,000–5,000', '5,000–10,000', '10,000+']

export const travelRequirement = [
    { value: 'Regularly', label: 'Regularly' },
    { value: 'Sometimes', label: 'Sometimes' },
    { value: 'Rarely', label: 'Rarely' },
    { value: 'Not Required', label: 'Not Required' },
]

export const jobType = [
    { value: 'Full-time', label: 'Full-time' },
    { value: 'Part-time', label: 'Part-time' },
    { value: 'Contract', label: 'Contract' },
    { value: 'Temporary', label: 'Temporary' },
    { value: 'Voluneer', label: 'Voluneer' },
    { value: 'Internship', label: 'Internship' },
    { value: 'Other', label: 'Other' }
]

export const personalityTypes = [
    { value: 'Excellent', label: 'Excellent' },
    { value: 'Good', label: 'Good' },
    { value: 'Normal', label: 'Normal' },
    { value: 'Poor', label: 'Poor' },
]